module.exports = __webpack_public_path__ + "img/mailTicket1.db4d0f53.png";